import { z } from 'zod';

import { optionalBoolean, optionalString, TransitAdditionalSupplyChainActorSchema, TransitDocumentSchema } from './utils';

export const TransitCommodityCodeSchema = z.object({
  hsCode: optionalString(),
  harmonizedSystemSubHeadingCode: optionalString(),
  combinedNomenclatureCode: optionalString(),
  initialAmountToPayForVat: optionalString(),
  initialAmountToPayForDuties: optionalString(),
});

export const DangerousGoodsSchema = z.object({
  sequenceNumber: optionalString(),
  UNNumber: optionalString(),
});

export const TransitGoodsMeasureSchema = z.object({
  grossMass: optionalString(),
  netMass: optionalString(),
  supplementaryUnits: optionalString(),
});

export const TransitCommoditySchema = z.object({
  descriptionOfGoods: optionalString(),
  CUSCode: optionalString(),
  CommodityCode: TransitCommodityCodeSchema.optional(),
  DangerousGoods: z.array(DangerousGoodsSchema).optional(),
  GoodsMeasure: TransitGoodsMeasureSchema.optional(),
});

export const TransitPackagingSchema = z.object({
  sequenceNumber: optionalString(),
  typeOfPackages: optionalString(),
  numberOfPackages: optionalString(),
  shippingMarks: optionalString(),
});

export const TransitConsignmentItemSchema = z.object({
  goodsItemNumber: optionalString(),
  declarationGoodsItemNumber: optionalString(),
  declarationType: optionalString(),
  countryOfDispatch: optionalString(),
  countryOfDestination: optionalString(),
  referenceNumberUCR: optionalString(),
  releaseType: optionalString(),
  receivedFromUnloadPermission: optionalBoolean(),
  isMissing: optionalBoolean(),
  AdditionalSupplyChainActor: z.array(TransitAdditionalSupplyChainActorSchema).optional(),
  Commodity: TransitCommoditySchema.optional(),
  Packaging: z.array(TransitPackagingSchema).optional(),
  PreviousDocument: z.array(TransitDocumentSchema).optional(),
  SupportingDocument: z.array(TransitDocumentSchema).optional(),
  AdditionalReference: z.array(TransitDocumentSchema).optional(),
  AdditionalInformation: z.array(TransitDocumentSchema).optional(),
  TransportDocument: z.array(TransitDocumentSchema).optional(),
});
export type TransitConsignmentItem = z.infer<typeof TransitConsignmentItemSchema>;

export const TransitGoodsItemSchema = TransitConsignmentItemSchema;
export type TransitGoodsItem = z.infer<typeof TransitGoodsItemSchema>;
